export default __webpack_public_path__ + "static/green-logo-af5fcf1f14da2439be39c91627535c21.svg";